export default "__VITE_ASSET__DcZxYmLw__"